// extracted by mini-css-extract-plugin
export default {"divider":"EaZVYF0V","title":"JwbBxFxR","lead":"Prvj6hPH"};